import Axios from 'axios';
import Serve from '../app/serve';

async function getPlanilhaFinanceiro() {
    const token = localStorage.getItem('token');
    const app = Serve();

    try {
        const response = await Axios.get(app + 'planilha_financeiro', {
            responseType: 'blob', // importante para arquivos
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });

        // Pega o nome do arquivo do header
        const disposition = response.headers['content-disposition'];
        let filename = 'planilha.xlsx'; // nome padrão

        if (disposition) {
            // Procura por 'filename=' no header
            const matches = disposition.match(/filename="?([^"]+)"?/);
      if (matches != null && matches[1]) {
        filename = matches[1];
      }

            console.log('foi');
        }else{
            console.log('não foi');
            console.log(response);
        }
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // nome sugerido
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);
    } catch (error) {
        console.error('Erro ao baixar planilha:', error);
        throw error;
    }
}

export default getPlanilhaFinanceiro;